// @flow
import type { Activity } from "data/app/types"
import { formatActivity } from "data/app/formatters"
import type { User } from "data/user/types"
import { tryTrack } from "../helpers"

const activityTrait = (a: Activity, u: ?User) => ({
  email: u && u.email,
  activity: formatActivity(a),
})

const productGroupTrait = (a: Activity, u: ?User) => ({
  email: u && u.email,
  productGroup: a.name,
})

export const trackActivity = (a: Activity, u: ?User) =>
  tryTrack("Activity", () => activityTrait(a, u))

export const trackProductGroup = (a: Activity, u: ?User) =>
  tryTrack("Product Group", () => productGroupTrait(a, u))



// WEBPACK FOOTER //
// ./src/analytics/app/analyticsTraits.js